module.exports = __webpack_public_path__ + "static/media/S3N3-6.68b02d56.svg";